$(document).ready(function () {
    // If there is a message in the dialog then show it 
    var modal = $('#newsletter-modal'),
        response = $('[class$="-response"] p', modal)
        ;
    
    if (response.length)
        modal.modal('show');
});